/**
 * Intention d'interaction transitoire (B10_05 — Interactions facturées).
 *
 * Certains fetches servent LE MÊME code au montage de la page et au geste du
 * lecteur (l'effet « enfant manquant » de ThreadMessageNode, le useQuery de
 * ThreadMessages remonté par un changement de tri…). Poser
 * `context: { gcInteraction: true }` en dur sur ces chemins facturerait chaque
 * chargement de page — le piège central de la revue B10_05.
 *
 * Ce module porte le pont : le HANDLER du geste signale une intention typée,
 * le FETCH la consomme (destructivement) dans une courte fenêtre. Un clic ne
 * peut donc marquer qu'UN fetch (les cascades de montage qui suivent trouvent
 * l'intention déjà consommée), et un fetch de montage sans geste ne trouve
 * jamais d'intention.
 *
 * ⚠ Chaque appel marqué est FACTURÉ au client : ne signaler que depuis un
 * handler d'événement utilisateur (onClick, scroll volontaire, saisie), jamais
 * depuis un effet de montage. La recette navigateur (onglet réseau, méthode
 * Paul) vérifie l'appariement geste → requête marquée avant toute MEP.
 */

// Fenêtre courte : le fetch part dans la foulée du geste (dispatch redux →
// re-render → effet/hook). 3 s absorbe les ticks async sans risquer de marquer
// un fetch sans rapport.
const FENETRE_MS = 3000;

let enAttente: { type: string; depuis: number } | null = null;

/** À appeler depuis le handler du GESTE (onClick, scrollend volontaire…). */
export function signalInteractionIntent(type: string): void {
  enAttente = { type, depuis: Date.now() };
}

/**
 * À appeler au moment du FETCH : rend `true` (une seule fois) si un geste du
 * type donné vient d'être signalé. Consommation destructive — la cascade qui
 * suit un geste ne marque qu'un appel.
 */
export function consumeInteractionIntent(type: string): boolean {
  if (enAttente && enAttente.type === type && Date.now() - enAttente.depuis < FENETRE_MS) {
    enAttente = null;
    return true;
  }
  return false;
}
